import { Box, Button, Card, Container, Typography } from '@mui/material'
import { useAuth } from '../../hooks/use-auth'
import miLaunchpadLogo from '../../assets/milaunchpad.png'

interface LoginPageProps {
  returnUrl?: string
}

export function LoginPage ({ returnUrl }: LoginPageProps): JSX.Element {
  const auth = useAuth()

  return <Box>
    <Typography variant='h1'> Login </Typography>
    <Box sx={{ display: 'flex', mt: '1.25em' }}>
      <Card>
        <Container>
          <Typography variant='h4' component='h1'>
            MiCredentials
          </Typography>

          <Typography variant='body1'>
            Use your MiCredentials login information to log in to START.
          </Typography>

          <Button
            variant='contained'
            color='primary'
            onClick={() => { auth.miCredsLogin(returnUrl) }}
            sx={{ mt: '1.25em', mb: '.625em', textTransform: 'none' }}
          >
            Login
          </Button>
        </Container>
      </Card>

      <Card sx={{ ml: '1.25em' }}>
        <Container>
          <Typography variant='h4' component='h1'>
            MiLaunchPad
          </Typography>

          <Typography variant='body1'>
            Use your local district login information to log in to START.
          </Typography>

          <Box>
            <img alt={'Powered by MiLaunchPad'} src={miLaunchpadLogo} />
          </Box>

          <Button
            variant='contained'
            color='primary'
            onClick={() => { auth.miLaunchPadLogin(returnUrl) }}
            sx={{ mt: '1.25em', mb: '.625em', textTransform: 'none' }}
          >
            Login
          </Button>
        </Container>
      </Card>
    </Box>
  </Box>
}
